import { httpClient } from '@/modules/common/services/http/http-client';
import { IMyAccountMenu } from '../../types';

const baseURL = `${process.env.VUE_APP_BFF_URL}/onboarding`;
export const httpClientAccountBFF = httpClient.withOptions({ baseURL });

export function getMyAccountMenu(customerId: string): Promise<IMyAccountMenu> {
  return httpClientAccountBFF.get(
    `/account/my-account-menu?customerId=${customerId}`
  );
}
